import React from 'react';
import { SecureRoute } from 'components/shared/secure_route';
import { connect } from 'react-redux';
import { ViewMounter } from '../../view_mounter';
import { Panel, PanelPresets, UserPermissionsIds } from '../../../utility/enumerations';

function MfaContainerScreen() {
  return (
    <div>
      <SecureRoute
        path="/mfa/selection"
        pathPermissionId={UserPermissionsIds.ReadMfa}
        exact
        render={(props) => ViewMounter(props, {
          viewPath: 'security/mfa/selection/display',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: true,
          overrideLocation: '',
          params: undefined
        })}
        allowAnonymous={false}
        component={undefined}
      />
    </div>
  );
}

export default connect(null)(MfaContainerScreen);
